import React from 'react';

const About = () => {
  return (
    <section id="about" className="section" aria-labelledby="about-title">
      <div className="container">
        <div className="about__content">
          <div className="about__image">
            <img 
              src="/assets/portfolio/swan-reflection.jpg" 
              alt="A swan preening on a rock, reflected in still golden-hour water"
              loading="lazy"
            />
          </div>
          <div className="about__text">
            <header className="section__header" style={{ textAlign: 'left', marginBottom: 'var(--spacing-lg)' }}>
              <span className="section__tagline">About Me</span>
              <h2 id="about-title" className="section__title">A dedicated photographer, fully invested in your shoot</h2>
            </header>
            <p>
              I'm a new photographer, and I'm building this business one client at a time.
              That means you won't be handed off to an associate or lost in a busy
              schedule. I'll be the one answering your message, planning the shoot, behind the
              camera, and editing every image.
            </p>
            {/* TODO(human): add one short paragraph in your own voice (see Learn by Doing) */}
            <p>
              Based in Oakville, Ontario, I serve agents, homeowners, businesses, and individuals
              throughout the Greater Toronto Area, and I deliver real estate galleries in 24–48 hours so
              your listing never waits on photos.
            </p>
            <div className="about__stats" role="list" aria-label="What to expect">
              <div className="stat" role="listitem">
                <div className="stat__number">1-on-1</div>
                <div className="stat__label">Same Photographer, Start to Finish</div>
              </div>
              <div className="stat" role="listitem">
                <div className="stat__number">24–48hr</div>
                <div className="stat__label">Listing Turnaround</div>
              </div>
              <div className="stat" role="listitem">
                <div className="stat__number">GTA</div>
                <div className="stat__label">Oakville-Based</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;